module.exports = __webpack_public_path__ + "img/double-image-hero-chevy.44031757.png";